<div
  class="asset-card col-12"
  [ngClass]="section.expanded ? 'asset-card-expanded' : 'asset-card-collapsed'"
>
  <div class="asset-card-header row">
    <h2 class="card-title asset-card-title col-10">
      {{ section.sectionTitle }}
    </h2>
    <div class="collapse-arrow col-2">
      <button
        class="action-button"
        (click)="section.expanded = !section.expanded"
      >
        <svg
          width="10"
          height="6"
          viewBox="0 0 10 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            [attr.d]="section.expanded ? 'M9 5L5 1L1 5' : 'M1 1L5 5L9 1'"
            stroke="#17171A"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>
  </div>

  <div *ngIf="section.expanded" class="asset-card-content" [@slideToggle]>
    <div
      class="asset-card-info row"
      *ngFor="let attr of section.attributeValues"
    >
      <ng-container [ngSwitch]="getRowType(attr)">
        <lib-attribute-number-edit-row
          *ngSwitchCase="'number-edit'"
          [attributeValue]="attr"
          [editedValues]="editedValues"
        >
        </lib-attribute-number-edit-row>

        <lib-attribute-text-edit-row
          *ngSwitchCase="'text-edit'"
          [attributeValue]="attr"
          [editedValues]="editedValues"
        >
        </lib-attribute-text-edit-row>

        <lib-attribute-date-edit-row
          *ngSwitchCase="'date-edit'"
          [attributeValue]="attr"
          [editedValues]="editedValues"
        >
        </lib-attribute-date-edit-row>

        <lib-attribute-image-edit-row
          *ngSwitchCase="'image-edit'"
          [attributeValue]="attr"
          [editedValues]="editedValues"
        >
        </lib-attribute-image-edit-row>

        <lib-attribute-dropdown-edit-row
          *ngSwitchCase="'dropdown-edit'"
          [attributeValue]="attr"
          [editedValues]="editedValues"
        >
        </lib-attribute-dropdown-edit-row>

        <lib-attribute-selected-options-row
          *ngSwitchCase="'selected-options'"
          [attributeValue]="attr"
        >
        </lib-attribute-selected-options-row>

        <lib-attribute-location-row
          *ngSwitchCase="'location'"
          [attributeValue]="attr"
          (mapClicked)="onMapClick($event)"
        >
        </lib-attribute-location-row>

        <lib-attribute-image-row
          *ngSwitchCase="'image'"
          [attributeValue]="attr"
          (mapClicked)="onMapClick($event)"
        >
        </lib-attribute-image-row>

        <lib-attribute-file-row *ngSwitchCase="'file'" [attributeValue]="attr">
        </lib-attribute-file-row>

        <lib-attribute-value-row
          *ngSwitchCase="'default'"
          [attributeValue]="attr"
        >
        </lib-attribute-value-row>
      </ng-container>
    </div>
  </div>
</div>
